GP.GPMod('TopOfSearch',function(self){
    var vent  = null;
    var _util = null;
    var _log  = null;

    var data = {
        // check and initialize a few params
        init: function() {
            vent  = self.vent;
            _util = self.app.Util;
            _log  = self.app.Util.log;
        },
        processing_get_on_top: false,
        min_views: 49,  // 50 views for production
    };
    var content_data = {};

    var gui = {
        init: function() {
            this.$body = $('body');
            this.$tos_view_wrap = $('#tos-view-wrap');
            this.$tos_view_count = $('#tos-view-count');
        }
    };

    var apis = {
        get_on_top: function(callback) {
            if (!data.processing_get_on_top) {
                data.processing_get_on_top = true;

                $.post('/members/user/top_of_search', {
                    'process' : 1
                })
                .done(function(json) {
                    if (json.status) {
                        data.processing_get_on_top = false;
                        events.setup_get_on_top(json);
                    }

                    if (_util.check_callable(callback)) {
                        callback();
                    }
                });
            }
        },
        get_views: function() {
            $.post('/members/search/get_top_of_search_views')
            .done(function(json) {
                if (json.status && json.views > data.min_views) {
                    // Update views
                    GP.sdata.my_user.get_on_top.views = json.views;
                    events.show_views();
                }
            });            
        }
    };

    var handlers = {

    };

    var events = {
        init: function() { 
            vent.on(self.moduleName+":setup_get_on_top_modal",events.setup_get_on_top_modal);
            vent.on(self.moduleName+":show_get_on_top",events.show_get_on_top);
            vent.on(self.moduleName+":get_on_top",apis.get_on_top);
        },
        setup_get_on_top_modal: function() {
            $('.btn-purchase-get-on-top').on('click', apis.get_on_top);

            // Triggered on add credits success
            $('body').one('on_top_credit_success', function(e) {
                setTimeout(function() {
                    events.setup_get_on_top({expire: GP.sdata.my_user.get_on_top.on_top_max});
                    apis.get_on_top();
                }, 3000);
            });
        },
        setup_get_on_top: function(json) {
            GP.sdata.my_user.get_on_top.on_top = true;
            if (typeof json !== 'undefined') {
                GP.sdata.my_user.get_on_top.expire = json.expire;
            }
            events.show_get_on_top();
            GP.vent.trigger('Modal:close');
        },
        show_get_on_top: function() {
            gui.$body.addClass('get-on-top-shown');
            $('#mobile-sidebar').addClass('!gp-top-[112px]');
            apis.get_views();
            events.get_on_top_expire();

            // Start timer to check/update views
            events.check_views();

            if (GP.sdata.my_user.get_on_top.views > data.min_views) {
                events.show_views();
            }
        },
        hide_get_on_top: function() {
            gui.$body.removeClass('get-on-top-shown');
            $('#mobile-sidebar').removeClass('!gp-top-[112px]');
            GP.sdata.my_user.get_on_top.on_top = false;
            events.hide_views();
        },
        // Hides the get on top bar when the 24hr period has ended.
        get_on_top_expire: function() {
            _util.timers.set(function() {
                events.hide_get_on_top();
            }, GP.sdata.my_user.get_on_top.expire, 'hide_get_on_top');
        },
        show_views: function() {
            gui.$tos_view_wrap.css('display', 'inline-block');
            gui.$tos_view_count.text(GP.sdata.my_user.get_on_top.views);
        },
        hide_views: function() {
            gui.$tos_view_wrap.css('display', 'none');
            _util.timers.clear('check_tos_views');
        },
        check_views: function() {
            var views_update_time = 20 * 1000; // 20 seconds
            _util.timers.set(function() {
                apis.get_views();
            }, views_update_time, 'check_tos_views', true);
        }

    };

    this.addInitializer(function(){
        data.init();
        events.init();
        gui.init();
    });
});
